export enum ENVIRONMENTS {
  uat = 'uat',
  development = 'development',
  production = 'production',
}
